import InvoiceDocument from '@payaca/components/invoiceDocument/InvoiceDocument';
import * as pdfDocumentDataActions from '@payaca/store/pdfDocumentData/pdfDocumentDataActions';
import { InvoicePdfDocumentData } from '@payaca/types/invoicePdfDocumentTypes';
import { FC, useEffect, useState, type JSX } from 'react';
import { useDispatch } from 'react-redux';
import { useIntercom } from 'react-use-intercom';
import './InvoicePage.sass';

type Props = {
  previewToken: string;
  invoiceId: number;
};

const InvoicePage: FC<Props> = ({
  previewToken,
  invoiceId,
}: Props): JSX.Element | null => {
  const dispatch = useDispatch();
  const [invoiceData, setInvoiceData] = useState<InvoicePdfDocumentData>();
  const { update } = useIntercom();

  useEffect(() => {
    dispatch(
      pdfDocumentDataActions.getInvoiceData.request({
        previewToken: previewToken,
        invoiceId: invoiceId,
        callback: setInvoiceData,
      })
    );

    update({ hideDefaultLauncher: true });

    return () => {
      update({ hideDefaultLauncher: false });
    };
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- FIXME: pre-existing error: React Hook useEffect has missing dependencies: 'invoiceId', 'previewToken', 'update', and 'dispatch'
  }, []);

  if (!invoiceData) return null;

  return (
    <div className="pdf-invoice-page">
      <InvoiceDocument
        documentSenderContext={invoiceData.documentSenderContext}
        invoiceId={invoiceId}
        jobLineItems={invoiceData.jobLineItems}
        invoices={invoiceData.invoices}
        invoiceLines={invoiceData.invoiceLines}
        customer={invoiceData.customer}
        siteAddresses={invoiceData.siteAddresses}
        dealTotals={invoiceData.dealTotals}
        invoiceGrants={invoiceData.invoiceGrants}
        hideItemPrices={invoiceData.hideItemPrices}
        paymentMethodConfig={invoiceData.paymentMethodConfig}
        isStraightToInvoice={invoiceData.isStraightToInvoice}
      />
    </div>
  );
};

export default InvoicePage;
